module.exports = __webpack_public_path__ + "static/media/clock.c5157745.svg";